import { render, staticRenderFns } from "./UpdateBlog.vue?vue&type=template&id=e730ea36&scoped=true"
import script from "./UpdateBlog.vue?vue&type=script&lang=js"
export * from "./UpdateBlog.vue?vue&type=script&lang=js"
import style0 from "./UpdateBlog.vue?vue&type=style&index=0&id=e730ea36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e730ea36",
  null
  
)

export default component.exports